/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommentAssociatedEntity } from './commentAssociatedEntity';
import { UserBasic } from './userBasic';

export interface CommentSearchView { 
    comment_sender: UserBasic;
    comment_associated_entity: CommentAssociatedEntity;
    comment_id: string;
    comment_text: string;
    comment_creation_date: string;
}